import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { useGetData } from "../../../../../hooks/useGetData";
import { useMutationData } from "../../../../../hooks/useMutationData";
import { EvaluadoInterface } from "../../../../../interfaces/EvaluadoInterface";
import { SemaforoPSInterface } from "../../../../../interfaces/SemaforoPSInterface";
import { ConclusionLlenadaPSInterface } from "../../../../../interfaces/ConclusionLlenadaPSInterface";
import { Loading } from "../../../../../components/Loading/Loading";
import { Label, TextInput } from "flowbite-react";
import { Button } from "flowbite-react";
import { API } from "../../../../../global/global";
import Semaforo from "../../../../../img/Semaforo.png";
import Rojo from "../../../../../img/Rojo.png";
import Amarillo from "../../../../../img/Amarillo.png";
import Verde from "../../../../../img/Verde.png";
import Header from "../../../../../components/HeaderForms/HeaderForms";
import { ThemeContext } from "../../../../../components/ThemeContext/ThemeContext";

export const ConclusionesPSCrearScreen = () => {
  const { isDarkMode } = useContext(ThemeContext);
  const tituloFormulario = "CONCLUSIONES DE EVALUACIÓN PSICOLÓGICA";
  const { control, reset, handleSubmit } = useForm();
  const { evaluadosList_id } = useParams<{ evaluadosList_id: string }>();
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const [images, setImages] = useState<string[]>([""]);
  const [notes, setNotes] = useState<string[]>([]);
  const [fechaNacimiento, setFechaNacimiento] = useState<string>("");
  const [edad, setEdad] = useState<number | null>(null);
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  const [formData, setFormData] = useState({
    date: "",
    name: "",
  });

  const calcularEdad = (fechaNacimiento: string) => {
    const fechaNac = new Date(fechaNacimiento);
    const hoy = new Date();
    let edadCalculada = hoy.getFullYear() - fechaNac.getFullYear();
    const mes = hoy.getMonth() - fechaNac.getMonth();

    if (mes < 0 || (mes === 0 && hoy.getDate() < fechaNac.getDate())) {
      edadCalculada--;
    }

    return edadCalculada;
  };

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    localStorage.setItem("formData", JSON.stringify(updatedFormData));
  };

  const handlePageChange = (newPage: number) => {
    const filledImages = images.filter((image) => image);
    setImages(filledImages.length > 0 ? filledImages : [""]);
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const savedFormData = localStorage.getItem("formData");
    const savedZones = localStorage.getItem("selectedZones");
    if (savedFormData) {
      setFormData(JSON.parse(savedFormData));
    }

    const savedImages = localStorage.getItem("images");
    if (savedImages) {
      setImages(JSON.parse(savedImages));
    }
  }, []);

  const resetFormData = () => {
    const emptyFormData = {
      visitDate: "",
      name: "",
      rfc: "",
      sex: "",
      civilStatus: "",
      education: "",
      birthDate: "",
      curp: "",
      company: "",
    };
    setImages([""]);
    localStorage.removeItem("images");
  };

  const handleImageChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const newImages = [...images];
        newImages[index] = reader.result as string;
        setImages(newImages);

        localStorage.setItem("images", JSON.stringify(newImages));
      };
      reader.readAsDataURL(file);
    }
  };

  const addImageBox = () => {
    setImages([...images, ""]);
    setNotes([...notes, ""]);
  };

  const removeImage = (index: number) => {
    const updatedImages = images.filter((_, i) => i !== index);
    const updatedNotes = notes.filter((_, i) => i !== index);
    setImages(updatedImages);
    setNotes(updatedNotes);
  };

  const renderHeader = () => (
    <>
      {/* Header */}
      <Header titulo={tituloFormulario} />
    </>
  );

  const handleNoteChange = (
    index: number,
    event: React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    const updatedNotes = [...notes];
    updatedNotes[index] = event.target.value;
    setNotes(updatedNotes);
  };

  const queryEvaluado = useGetData<EvaluadoInterface>({
    url: `/evaluado/${evaluadosList_id}`,
    name: ["evaluado"],
  });

  const queryConclusionPS = useGetData<ConclusionLlenadaPSInterface>({
    url: `/conclusionllenada_ps/${evaluadosList_id}`,
    name: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_ps"],
  });

  const mutateFechaPS = useMutationData({
    url: `/fecha_psico/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "fecha_psico"],
  });

  const mutateConclusionPS = useMutationData({
    url: `/conclusionllenada_ps/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "conclusionllenada_ps"],
  });

  const mutateResultadoPS = useMutationData({
    url: `/resultado-conclusionps/${evaluadosList_id}`,
    reload: ["evaluado", `${evaluadosList_id}`, "resultado-conclusionps"],
  });

  const mutateSemaforoPS = useMutationData({
    url: `/semaforoPS/${evaluadosList_id}`,
    reload: ["evaluado", "semaforoPS", `${evaluadosList_id}`],
  });

  const normalizeString = (str: string) => {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  };

  const nombreCompleto = normalizeString(
    `${queryEvaluado.data?.nombre}_${queryEvaluado.data?.apellido_paterno}_${queryEvaluado.data?.apellido_materno}`.replace(
      /\s/g,
      "_"
    )
  );

  const [selectedImage, setSelectedImage] = useState(Semaforo);
  const [selectedRecommendation, setSelectedRecommendation] = useState<
    string | null
  >(null);

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSelectedRecommendation(value);

    if (value === "recomendable") {
      setSelectedImage(Verde);
    } else if (value === "con_reserva") {
      setSelectedImage(Amarillo);
    } else if (value === "no_recomendable") {
      setSelectedImage(Rojo);
    }
  };

  const handlePrint = () => {
    const printContent = document.getElementById("printableContent");

    if (printContent) {
      const originalContent = document.body.innerHTML;

      const printWindow = window.open("", "", "width=800,height=600");

      if (printWindow) {
        printWindow.document.write(
          "<html><head><title>Vista Previa de Impresión</title>"
        );

        const styles = document.getElementsByTagName("style");
        for (let i = 0; i < styles.length; i++) {
          printWindow.document.write(styles[i].outerHTML);
        }
        printWindow.document.write("</head><body>");
        printWindow.document.write(printContent.innerHTML);
        printWindow.document.write("</body></html>");
        printWindow.document.close();
        printWindow.onload = () => {
          printWindow.print();
          printWindow.close();
        };
      } else {
        alert(
          "No se pudo abrir la ventana de impresión. Verifique las configuraciones del navegador."
        );
      }
    }
  };

  useEffect(() => {
    if (queryEvaluado.data) {
      const fechaNac = queryEvaluado.data.fecha_nacimiento || "";
      setFechaNacimiento(fechaNac);

      const nuevaEdad = calcularEdad(fechaNac);
      setEdad(nuevaEdad);

      reset({
        nombre: queryEvaluado.data.nombre || "",
        apellido_paterno: queryEvaluado.data.apellido_paterno || "",
        apellido_materno: queryEvaluado.data.apellido_materno || "",
        rfc: queryEvaluado.data.rfc || "",
        genero: queryEvaluado.data.genero || "",
        estado_civil: queryEvaluado.data.estado_civil || "",
        escolaridad: queryEvaluado.data.escolaridad || "",
        fecha_nacimiento: fechaNac,
        curp: queryEvaluado.data.curp || "",
        empresa: queryEvaluado.data.empresa?.nombre || "",
        lugar_nacimiento: queryEvaluado.data.lugar_nacimiento || "",
      });
    }
  }, [queryEvaluado.data, reset]);

  useEffect(() => {
    if (evaluadosList_id) {
      const token = localStorage.getItem("token");
      fetch(`${API}/evaluados/${evaluadosList_id}/photo/${nombreCompleto}`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.url) {
            setPhotoUrl(data.url);
          } else {
            setPhotoUrl(null);
          }
        })
        .catch((error) => {
          console.error("Error al obtener la URL de la foto:", error);
          setPhotoUrl(null);
        });
    }
  }, [evaluadosList_id, nombreCompleto]);

  if (queryEvaluado.isLoading) {
    return <Loading />;
  }

  const renderPage1 = () => (
    <div className={`space-y-4 p-4 ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white text-black"}`}>
      <div className="grid grid-cols-3 gap-4">
        {/* Fecha Visita */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fecha_conclusionps" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-black"}`}>
            FECHA EVALUACIÓN:
          </Label>
          <Controller
            name="fecha_conclusionps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="fecha_conclusionps"
                type="date"
                {...field}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
              />
            )}
          />
        </div>
        {/* Campo para nombre */}
        <div className="col-span-2">
          <Label htmlFor="nombre" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>NOMBRE:</Label>
          <TextInput
            id="nombre"
            name="nombre"
            value={`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>

        {/* FOTO */}
        <div className={`w-64 h-64 border rounded-md overflow-hidden flex items-center justify-center mt-4 relative z-10 ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-100 border-gray-300"}`}>
          {photoUrl ? (
            <img
              src={photoUrl}
              alt="Foto de evaluado"
              className="w-full h-full object-cover"
            />
          ) : (
            <span className={`${isDarkMode ? "text-gray-400" : "text-gray-500"}`}>Sin foto disponible</span>
          )}
        </div>
        {/* SEMAFORO */}
        <div className="flex items-center gap-4">
          {/* Radio buttons */}
          <div className="flex flex-col">
            <label className={`flex items-center gap-2 mt-4 mb-4 ${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <input
                type="radio"
                name="recommendation"
                value="recomendable"
                onChange={handleRadioChange}
              />
              RECOMENDABLE
            </label>
            <label className={`flex items-center gap-2 mt-12 mb-12 ${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <input
                type="radio"
                name="recommendation"
                value="con_reserva"
                onChange={handleRadioChange}
              />
              CON RESERVA
            </label>
            <label className={`flex items-center gap-2 mb-12 ${isDarkMode ? "text-gray-200" : "text-black"}`}>
              <input
                type="radio"
                name="recommendation"
                value="no_recomendable"
                onChange={handleRadioChange}
              />
              NO RECOMENDABLE
            </label>
          </div>
          {/* Imagen de Semaforo */}
          <img src={selectedImage} alt="Semaforo" className="w-70 h-70" />
        </div>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {/* Campo para RFC */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>RFC:</Label>
          <TextInput
            id="rfc"
            name="rfc"
            onChange={handleInputChange}
            value={queryEvaluado.data?.rfc || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Edad */}
        <div className="col-span-1">
          <Label htmlFor="edad" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>EDAD:</Label>
          <TextInput
            id="edad"
            name="edad"
            value={edad !== null ? edad.toString() : ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Género */}
        <div className="col-span-1">
          <Label htmlFor="sexo" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>SEXO:</Label>
          <TextInput
            id="sexo"
            name="sexo"
            onChange={handleInputChange}
            value={queryEvaluado.data?.genero || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Estado Civil */}
        <div className="col-span-1">
          <Label htmlFor="estadoCivil" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>ESTADO CIVIL:</Label>
          <TextInput
            id="estadoCivil"
            name="estadoCivil"
            onChange={handleInputChange}
            value={queryEvaluado.data?.estado_civil || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Escolaridad */}
        <div className="col-span-1">
          <Label htmlFor="escolaridad" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>ESCOLARIDAD:</Label>
          <TextInput
            id="escolaridad"
            name="escolaridad"
            onChange={handleInputChange}
            value={queryEvaluado.data?.escolaridad || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Fecha de Nacimiento */}
        <div className="col-span-1 flex items-center">
          <Label htmlFor="fechaNacimiento" className={`mr-2 ${isDarkMode ? "text-gray-200" : "text-black"}`}>
            FECHA DE NACIMIENTO:
          </Label>
          <TextInput
            id="fechaNacimiento"
            name="fechaNacimiento"
            value={queryEvaluado.data?.fecha_nacimiento || ""}
            disabled={true}
            type="date"
            className={`w-32 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* CURP */}
        <div className="col-span-1">
          <Label htmlFor="curp" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>CURP:</Label>
          <TextInput
            id="curp"
            name="curp"
            onChange={handleInputChange}
            value={queryEvaluado.data?.curp || ""}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
        {/* Empresa */}
        <div className="col-span-1">
          <Label htmlFor="empresa" className={`${isDarkMode ? "text-gray-200" : "text-black"}`}>EMPRESA:</Label>
          <TextInput
            id="empresa_id"
            name="empresa"
            value={queryEvaluado.data?.empresa_id?.nombre || ""}
            onChange={handleInputChange}
            disabled={true}
            className={`${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 disabled:opacity-75 disabled:bg-gray-600 disabled:text-gray-300" : "bg-white text-gray-900 border-gray-300"}`}
          />
        </div>
      </div>
    </div>
  );

  const renderPage2 = () => (
    <div className={`space-y-6 p-6 rounded-lg shadow-md ${isDarkMode ? "bg-gray-800" : "bg-gray-50"}`}>
      <div className={`p-4 rounded-lg shadow ${isDarkMode ? "bg-blue-800 text-white" : "bg-customBlue text-white"}`}>
        <h2 className="font-bold text-xl">
          CONCLUSIONES DE EVALUACIÓN PSICOLÓGICA
        </h2>
      </div>

      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>CONCLUSIÓN</p>

        <div className="flex flex-col space-y-8">
          {/* Tabla COMPETENCIAS LABORALES */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-700" : "text-gray-800 border-gray-200"}`}>
              COMPETENCIAS LABORALES
            </h2>

            <div className="overflow-x-auto">
              <table className={`w-full divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                <thead className={`${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
                  <tr>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      Competencia
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      RECOMENDABLE
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      CON RESERVA
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      NO RECOMENDABLE
                    </th>
                  </tr>
                </thead>
                <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                  {/* Adaptabilidad */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      ADAPTABILIDAD
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="adaptabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="adaptabilidad2_ps"
                            type="radio"
                            {...field}
                            name="adaptabilidad2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="adaptabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="adaptabilidad2_ps"
                            type="radio"
                            {...field}
                            name="adaptabilidad2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="adaptabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="adaptabilidad2_ps"
                            type="radio"
                            {...field}
                            name="adaptabilidad2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Responsabilidad */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      RESPONSABILIDAD
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="responsabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="responsabilidad2_ps"
                            type="radio"
                            {...field}
                            name="responsabilidad2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="responsabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="responsabilidad2_ps"
                            type="radio"
                            {...field}
                            name="responsabilidad2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="responsabilidad2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="responsabilidad2_ps"
                            type="radio"
                            {...field}
                            name="responsabilidad2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Trabajo en equipo */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      TRABAJO EN EQUIPO
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="trabajoequipo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="trabajoequipo2_ps"
                            type="radio"
                            {...field}
                            name="trabajoequipo2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="trabajoequipo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="trabajoequipo2_ps"
                            type="radio"
                            {...field}
                            name="trabajoequipo2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="trabajoequipo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="trabajoequipo2_ps"
                            type="radio"
                            {...field}
                            name="trabajoequipo2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Toma de decisiones */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      TOMA DE DECISIONES
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="tomadecisiones2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomadecisiones2_ps"
                            type="radio"
                            {...field}
                            name="tomadecisiones2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="tomadecisiones2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomadecisiones2_ps"
                            type="radio"
                            {...field}
                            name="tomadecisiones2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="tomadecisiones2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="tomadecisiones2_ps"
                            type="radio"
                            {...field}
                            name="tomadecisiones2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Tolerancia a la presión */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      TOLERANCIA A LA PRESIÓN
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciapresion2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciapresion2_ps"
                            type="radio"
                            {...field}
                            name="toleranciapresion2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciapresion2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciapresion2_ps"
                            type="radio"
                            {...field}
                            name="toleranciapresion2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciapresion2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciapresion2_ps"
                            type="radio"
                            {...field}
                            name="toleranciapresion2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Compromiso laboral */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      COMPROMISO LABORAL
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="compromisolaboral2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="compromisolaboral2_ps"
                            type="radio"
                            {...field}
                            name="compromisolaboral2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="compromisolaboral2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="compromisolaboral2_ps"
                            type="radio"
                            {...field}
                            name="compromisolaboral2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="compromisolaboral2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="compromisolaboral2_ps"
                            type="radio"
                            {...field}
                            name="compromisolaboral2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Liderazgo */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      LIDERAZGO
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="liderazgo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="liderazgo2_ps"
                            type="radio"
                            {...field}
                            name="liderazgo2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="liderazgo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="liderazgo2_ps"
                            type="radio"
                            {...field}
                            name="liderazgo2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="liderazgo2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="liderazgo2_ps"
                            type="radio"
                            {...field}
                            name="liderazgo2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Iniciativa */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      INICIATIVA
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="iniciativa2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="iniciativa2_ps"
                            type="radio"
                            {...field}
                            name="iniciativa2_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="iniciativa2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="iniciativa2_ps"
                            type="radio"
                            {...field}
                            name="iniciativa2_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="iniciativa2_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="iniciativa2_ps"
                            type="radio"
                            {...field}
                            name="iniciativa2_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tabla PERSONALIDAD */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-700" : "text-gray-800 border-gray-200"}`}>
              PERSONALIDAD
            </h2>

            <div className="overflow-x-auto">
              <table className={`w-full divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                <thead className={`${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
                  <tr>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      Competencia
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      RECOMENDABLE
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      CON RESERVA
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      NO RECOMENDABLE
                    </th>
                  </tr>
                </thead>
                <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                  {/* Fortaleza Yoica */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      FORTALEZA YOICA
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="fortalezayoica_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="fortalezayoica_ps"
                            type="radio"
                            {...field}
                            name="fortalezayoica_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="fortalezayoica_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="fortalezayoica_ps"
                            type="radio"
                            {...field}
                            name="fortalezayoica_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="fortalezayoica_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="fortalezayoica_ps"
                            type="radio"
                            {...field}
                            name="fortalezayoica_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Tolerancia a la Frustración */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      TOLERANCIA A LA FRUSTRACIÓN
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciafrustracion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciafrustracion_ps"
                            type="radio"
                            {...field}
                            name="toleranciafrustracion_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciafrustracion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciafrustracion_ps"
                            type="radio"
                            {...field}
                            name="toleranciafrustracion_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="toleranciafrustracion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="toleranciafrustracion_ps"
                            type="radio"
                            {...field}
                            name="toleranciafrustracion_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Seguridad en sí mismo */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      SEGURIDAD EN SÍ MISMO
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="seguridadsimismo_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="seguridadsimismo_ps"
                            type="radio"
                            {...field}
                            name="seguridadsimismo_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="seguridadsimismo_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="seguridadsimismo_ps"
                            type="radio"
                            {...field}
                            name="seguridadsimismo_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="seguridadsimismo_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="seguridadsimismo_ps"
                            type="radio"
                            {...field}
                            name="seguridadsimismo_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Control de Impulsos */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      CONTROL DE IMPUSLOS
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="controlimpulsos_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="controlimpulsos_ps"
                            type="radio"
                            {...field}
                            name="controlimpulsos_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="controlimpulsos_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="controlimpulsos_ps"
                            type="radio"
                            {...field}
                            name="controlimpulsos_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="controlimpulsos_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="controlimpulsos_ps"
                            type="radio"
                            {...field}
                            name="controlimpulsos_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Relaciones Interpersonales */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      RELACIONES INTERPERSONALES
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="relacionesinterpersonales_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="relacionesinterpersonales_ps"
                            type="radio"
                            {...field}
                            name="relacionesinterpersonales_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="relacionesinterpersonales_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="relacionesinterpersonales_ps"
                            type="radio"
                            {...field}
                            name="relacionesinterpersonales_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="relacionesinterpersonales_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="relacionesinterpersonales_ps"
                            type="radio"
                            {...field}
                            name="relacionesinterpersonales_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Internalización Normas y Valores */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      INTERNALIZACIÓN NORMAS Y VALORES
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="internalizacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="internalizacion_ps"
                            type="radio"
                            {...field}
                            name="internalizacion_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="internalizacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="internalizacion_ps"
                            type="radio"
                            {...field}
                            name="internalizacion_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="internalizacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="internalizacion_ps"
                            type="radio"
                            {...field}
                            name="internalizacion_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Estabilidad Emocional */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      ESTABILIDAD EMOCIONAL
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="estabilidademocional_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estabilidademocional_ps"
                            type="radio"
                            {...field}
                            name="estabilidademocional_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="estabilidademocional_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estabilidademocional_ps"
                            type="radio"
                            {...field}
                            name="estabilidademocional_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="estabilidademocional_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="estabilidademocional_ps"
                            type="radio"
                            {...field}
                            name="estabilidademocional_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Contacto con la realidad */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      CONTACTO CON LA REALIDAD
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="contactorealidad_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="contactorealidad_ps"
                            type="radio"
                            {...field}
                            name="contactorealidad_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="contactorealidad_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="contactorealidad_ps"
                            type="radio"
                            {...field}
                            name="contactorealidad_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="contactorealidad_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="contactorealidad_ps"
                            type="radio"
                            {...field}
                            name="contactorealidad_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Manejo del Estrés */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      MANEJO DEL ESTRÉS
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="manejoestres_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="manejoestres_ps"
                            type="radio"
                            {...field}
                            name="manejoestres_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="manejoestres_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="manejoestres_ps"
                            type="radio"
                            {...field}
                            name="manejoestres_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="manejoestres_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="manejoestres_ps"
                            type="radio"
                            {...field}
                            name="manejoestres_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Tabla ESFERA INTELECTUAL */}
          <div className={`rounded-lg shadow-md p-6 ${isDarkMode ? "bg-gray-800" : "bg-white"}`}>
            <h2 className={`text-xl font-semibold mb-4 border-b pb-2 ${isDarkMode ? "text-gray-200 border-gray-700" : "text-gray-800 border-gray-200"}`}>
              ESFERA INTELECTUAL
            </h2>

            <div className="overflow-x-auto">
              <table className={`w-full divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                <thead className={`${isDarkMode ? "bg-gray-700" : "bg-gray-50"}`}>
                  <tr>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-left text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      Competencia
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      RECOMENDABLE
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      CON RESERVA
                    </th>
                    <th
                      scope="col"
                      className={`w-1/4 px-6 py-3 text-center text-xs font-medium uppercase tracking-wider ${isDarkMode ? "text-gray-400" : "text-gray-500"}`}
                    >
                      NO RECOMENDABLE
                    </th>
                  </tr>
                </thead>
                <tbody className={`${isDarkMode ? "bg-gray-900 text-gray-200" : "bg-white text-gray-900"} divide-y ${isDarkMode ? "divide-gray-700" : "divide-gray-200"}`}>
                  {/* Aprendizaje y Memoria */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      APRENDIZAJE Y MEMORIA
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="aprendizajememoria_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="aprendizajememoria_ps"
                            type="radio"
                            {...field}
                            name="aprendizajememoria_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="aprendizajememoria_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="aprendizajememoria_ps"
                            type="radio"
                            {...field}
                            name="aprendizajememoria_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="aprendizajememoria_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="aprendizajememoria_ps"
                            type="radio"
                            {...field}
                            name="aprendizajememoria_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Juicio Práctico */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      JUICIO PRÁCTICO
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="juiciopractico_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="juiciopractico_ps"
                            type="radio"
                            {...field}
                            name="juiciopractico_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="juiciopractico_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="juiciopractico_ps"
                            type="radio"
                            {...field}
                            name="juiciopractico_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="juiciopractico_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="juiciopractico_ps"
                            type="radio"
                            {...field}
                            name="juiciopractico_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Pensamiento Concreto */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      PENSAMIENTO CONCRETO
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="pensamientoconcreto_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="pensamientoconcreto_ps"
                            type="radio"
                            {...field}
                            name="pensamientoconcreto_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="pensamientoconcreto_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="pensamientoconcreto_ps"
                            type="radio"
                            {...field}
                            name="pensamientoconcreto_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="pensamientoconcreto_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="pensamientoconcreto_ps"
                            type="radio"
                            {...field}
                            name="pensamientoconcreto_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>

                  {/* Organización y Planeación */}
                  <tr>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-sm font-medium text-left">
                      Organización y Planeación
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="organizacionplaneacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="organizacionplaneacion_ps"
                            type="radio"
                            {...field}
                            name="organizacionplaneacion_ps"
                            value="RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="organizacionplaneacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="organizacionplaneacion_ps"
                            type="radio"
                            {...field}
                            name="organizacionplaneacion_ps"
                            value="CON RESERVA"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                    <td className="w-1/4 px-6 py-4 whitespace-nowrap text-center">
                      <Controller
                        name="organizacionplaneacion_ps"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <input
                            id="organizacionplaneacion_ps"
                            type="radio"
                            {...field}
                            name="organizacionplaneacion_ps"
                            value="NO RECOMENDABLE"
                            className={`h-4 w-4 text-blue-600 focus:ring-blue-500 ${isDarkMode ? "border-gray-600" : "border-gray-300"}`}
                          />
                        )}
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Derivado de la valoriación y revisión de la información, se considera
            que es una persona{" "}
            <Controller
                name="habitos_ps"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <input
                        {...field}
                        id="habitos_ps"
                        type="text"
                        className={`border rounded-md p-2 w-[400px] inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                        placeholder="¿Como es?"
                    />
                )}
            />
            , en virtud de que al momento de la evaluación psicológica, se detectó
            que:
            <Controller
                name="relaciones_interps"
                control={control}
                defaultValue=""
                render={({ field }) => (
                    <textarea
                        {...field}
                        id="relaciones_interps"
                        className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                        aria-label="relaciones_interps"
                        placeholder="Escribe lo que detectarón aquí..."
                    />
                )}
            />
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se procedió a la revisión minuciosa de todos y cada uno de los
          documentos que el candidato exhibió, los siguientes:
        </p>
      </div>

       <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>AMBITO FAMILIAR</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          refiere ser{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.estado_civil || ""}`}
          </label>
          , su familia se conforma de{" "}
          <Controller
            name="conforma_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="conforma_ps"
                type="number"
                className={`border rounded-md p-2 w-14 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                placeholder="00"
              />
            )}
          />{" "}
          integrantes{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.integrantes_ps || ""}`}
          </label>
          , comenta que se identifica con{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.identifica_ps || ""}`}
          </label>{" "}
          de su familia porque{" "}
          <Controller
            name="familiaporque_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="familiaporque_ps"
                type="text"
                className={`border rounded-md p-2 w-auto inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                placeholder="Razón"
              />
            )}
          />
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Menciona que la relación con su familia es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.relacionfam_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>PERSONALIDAD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryEvaluado.data?.nombre || ""} ${
              queryEvaluado.data?.apellido_paterno || ""
            } ${queryEvaluado.data?.apellido_materno || ""}`}
          </label>{" "}
          es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.personalidad_ps || ""}`}
          </label>{" "}
          y se describe como{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.describe_ps || ""}`}
          </label>
          . Reseña que lo que más le han criticado de su forma de ser es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.formaser_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          RELACIONES INTERPERSONALES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Explica que las personas con las que se identifica son{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.personas_identificaps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>HÁBITOS</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Refiere que{" "}
          <Controller
            name="conocedrogas_ps"
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <select
                {...field}
                id="conocedrogas_ps"
                className={`border rounded-md p-2 w-20 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                onChange={(e) => {
                  const value =
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null;
                  field.onChange(value);
                }}
              >
                <option value="">Elige</option>
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />{" "}
          conoce drogas y que{" "}
          <Controller
            name="consumealcohol_ps"
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <select
                {...field}
                id="consumealcohol_ps"
                className={`border rounded-md p-2 w-20 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                onChange={(e) => {
                  const value =
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null;
                  field.onChange(value);
                }}
              >
                <option value="">Elige</option>
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />{" "}
          consume alcohol cuando{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.cuandoconsume_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          APEGO A NORMAS Y VALORES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Comenta que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {queryConclusionPS.data?.procedimientosadm_ps === true
              ? "Si"
              : queryConclusionPS.data?.procedimientosadm_ps === false
              ? "No"
              : "No especificado"}
          </label>{" "}
          tiene procedimientos administrativos y/o jurídicos. También menciona
          que sus jefes y maestros opinan que es una persona{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.opinionpersona_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Nos cuenta que lo mejor que ha hecho hasta el día de hoy es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.mejor_ps || ""}`}
          </label>{" "}
          y que lo peor que ha hecho al día de hoy es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.peor_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          CONTROL DE IMPULSOS
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Explica que los motivos por los que se enoja son:
        </p>
        <Controller
          name="motivoenojo_ps"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              id="motivoenojo_ps"
              value={
                field.value || `${queryConclusionPS.data?.motivoenojo_ps || ""}`
              }
              disabled={true}
              className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
              aria-label="motivoenojo_ps"
              placeholder="Describe los motivos de enojo aquí..."
            />
          )}
        />
        <p className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          y que cuando es agredido reacciona{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.agredido_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          ¿Participó en riñas?{" "}
          <Controller
            name="riñaparticipo_ps"
            control={control}
            defaultValue={null}
            render={({ field }) => (
              <select
                {...field}
                id="riñaparticipo_ps"
                className={`border rounded-md p-2 w-20 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                onChange={(e) => {
                  const value =
                    e.target.value === "true"
                      ? true
                      : e.target.value === "false"
                      ? false
                      : null;
                  field.onChange(value);
                }}
              >
                <option value="">Elige</option>
                <option value="true">Sí</option>
                <option value="false">No</option>
              </select>
            )}
          />
          , la última riña en la que participó fue{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.cualriña_ps || ""}`}
          </label>{" "}
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Refiere que su estado de ánimo actual es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.estadoanimo_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          El acontecimiento más triste que ha vivido es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.acontecimientotriste_ps || ""}`}
          </label>{" "}
          y que la tristeza en su vida se refleja{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tristezavida_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>SALUD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Durante la entrevista señaló que considera su estado de salud{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.estadosalud_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ENFERMEDADES</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Que ha llevado o cuenta con{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tratamientomedico_ps || ""}`}
          </label>{" "}
          tratamiento médico prolongado derivado de{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.derivado1_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Tratamiento psicológico o psiquiátrico, refiere{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tratamientops_ps || ""}`}
          </label>
          .
        </p>
      </div>
       <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ÁMBITO LABORAL</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le cuestionó al evaluado el motivo por el que entró a trabajar a la
          empresa y refirió que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.motivo_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También que se enteró de la vacante por{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.enterovacante_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le preguntó también su opinión de los problemas que se pueden
          presentar en la empresa y al respecto dijo que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.problemasempresa_ps || ""}`}
          </label>
          , asimismo menciona que puede contribuir a resolverlos{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.resolverproblemas_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Reseña de sus empleos anteriores{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.reseñaempleos_ps || ""}`}
          </label>
          .
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            Realizó la siguiente descripción de lo que más le gusta de su último
            trabajo:{" "}
            <Controller
              name="descripciongustatrabajo_ps"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  id="descripciongustatrabajo_ps"
                  value={
                    field.value ||
                    `${
                      queryConclusionPS.data?.descripciongustatrabajo_ps || ""
                    }`
                  }
                  disabled={true}
                  className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                  aria-label="descripciongustatrabajo_ps"
                  placeholder="Descripción de su último trabajo..."
                />
              )}
            />
          </p>
        </div>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            También explicó lo que menos le gustaba de su último trabajo:{" "}
            <Controller
              name="descripciondisgustatrabajo_ps"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  id="descripciondisgustatrabajo_ps"
                  value={
                    field.value ||
                    `${
                      queryConclusionPS.data?.descripciondisgustatrabajo_ps ||
                      ""
                    }`
                  }
                  disabled={true}
                  className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                  aria-label="descripciondisgustatrabajo_ps"
                  placeholder="Descripción de su último trabajo..."
                />
              )}
            />
          </p>
        </div>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que la relación con sus jefes y compañeros ha sido{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.relacionjefecomp_ps || ""}`}
          </label>
          . Y que la situación más difícil que ha enfrentado en el trabajo es{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.situaciontrabajo_ps || ""}`}
          </label>
          .
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            El evaluado explicó que su mayor logro personal y laboral son:{" "}
            <Controller
              name="logropersonal_ps"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  id="logropersonal_ps"
                  value={
                    field.value ||
                    `${
                      queryConclusionPS.data?.logropersonal_ps || ""
                    } y el logro laboral es ${
                      queryConclusionPS.data?.logrolaboral_ps || ""
                    }`
                  }
                  disabled={true}
                  className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                  aria-label="logropersonal_ps"
                  placeholder="Mayor logro personal y laboral"
                />
              )}
            />
          </p>
        </div>
        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También refirió que en una situación imprevista o bajo presión en la
          que tuvo que tomar decisiones, actuó{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.situacionimprevista_ps || ""}`}
          </label>{" "}
          y el resultado que obtuvo.{" "}
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          ACTIVIDADES EN LOS TIEMPOS LIBRES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          El evaluado explica que las actividades que realiza en los tiempos
          libres son{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tiempolibre_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          COMPETENCIAS LABORALES
        </p>

        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>ADAPTABILIDAD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.adaptacion_ps || ""}`}
          </label>{" "}
          se adapta a nuevas actividades y a los cambios laborales como
          sociales.
        </p>

        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RESPONSABILIDAD</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Manifiesta que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.manifiesta_ps || ""}`}
          </label>{" "}
          con la entrega de trabajos el día y hora que se requieren.
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Indica que acude{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.indicaacude_ps || ""}`}
          </label>{" "}
          a trabajar en los horarios establecidos de manera puntual.
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>TRABAJO EN EQUIPO</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Se le cuestionó con qué facilidad se le adapta a trabajar en equipo y
          mencionó que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.adaptaequipo_ps || ""}`}
          </label>
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          TOMA DE DECISIONES
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          También señala que en situaciones de emergencia en sus actividades
          laborales toma decisiones{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.tomadecision_ps || ""}`}
          </label>{" "}
          para solucionar el conflicto.
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          TOLERANCIA A LA PRESIÓN
        </p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          En este espacio se escribe lo que el evaluado refirió en el
          cuestionario en tolerancia a la presión porque va a mencionar un
          proyecto desafiante con fecha límite, etc.{" "}
          <Controller
            name="tolerancia_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="tolerancia_ps"
                value={
                  field.value ||
                  `${queryConclusionPS.data?.tolerancia_ps || ""}`
                }
                disabled={true}
                className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                aria-label="tolerancia_ps"
                placeholder="Descripción..."
              />
            )}
          />
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          COMPROMISO LABORAL
        </p>
        <div className="w-full">
          <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
            El evaluado mencionó que:{" "}
            <Controller
              name="compromiso_ps"
              control={control}
              defaultValue=""
              render={({ field }) => (
                <textarea
                  id="compromiso_ps"
                  value={
                    field.value ||
                    `${queryConclusionPS.data?.compromiso_ps || ""}`
                  }
                  disabled={true}
                  className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                  aria-label="compromiso_ps"
                  placeholder="Descripción..."
                />
              )}
            />
          </p>
        </div>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>LIDERAZGO</p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Tomar respuesta del cuestionario, ya que el evaluado mencionará
          brevemente un momento donde demostró sus habilidades de liderazgo.{" "}
          <Controller
            name="lider_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="lider_ps"
                value={
                  field.value || `${queryConclusionPS.data?.lider_ps || ""}`
                }
                disabled={true}
                className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                aria-label="lider_ps"
                placeholder="Descripción..."
              />
            )}
          />
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>INICIATIVA</p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          El evaluado manifiesta que en{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.ocasion_ps || ""}`}
          </label>{" "}
          tuvo que asumir mayor responsabilidad en su lugar de trabajo que lo
          que le correspondía hacer, derivado de que{" "}
          <label
            htmlFor="nombre"
            className={`font-medium inline-block ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}
          >
            {`${queryConclusionPS.data?.derivado2_ps || ""}`}
          </label>
          .
        </p>

        <p className={`text-left leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Señala que sus objetivos inmediatos son{" "}
          <Controller
            name="objetivos_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <textarea
                id="objetivos_ps"
                value={
                  field.value || `${queryConclusionPS.data?.objetivos_ps || ""}`
                }
                disabled={true}
                className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
                aria-label="objetivos_ps"
                placeholder="Objetivos inmediatos"
              />
            )}
          />{" "}
          y para conseguirlos hace{" "}
          <Controller
            name="conseguirobj_ps"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <input
                {...field}
                id="conseguirobj_ps"
                type="text"
                className={`border rounded-md p-2 w-64 inline-block mt-2 mb-2 focus:ring-2 focus:ring-indigo-400 ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-700 border-gray-300 placeholder-gray-500"}`}
                placeholder="Acciones para lograr objetivos"
              />
            )}
          />
          .
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          CONDUCTA EN EL EXAMEN
        </p>

        <p className={`text-justify leading-relaxed ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>
          Al momento de realizar la evaluación, mencionó estar en buen estado de
          salud, psicológico y emocional para llevar a cabo la evaluación, por
          lo que durante la entrevista manifestó entender de manera clara y
          oportuna los cuestionamientos que se le realizaron; cabe señalar que
          durante el examen aseveró presentarse de manera voluntaria asentado su
          consentimiento mediante la firma del formato de autorización, aunado a
          lo anterior acató de manera clara y precisa las indicaciones que se le
          proporcionaron, por lo que la prueba se concluyó sin problema alguno.{" "}
        </p>
      </div>
      <div className={`flex flex-col items-start border-dashed border-4 rounded-lg p-6 space-y-6 relative ${isDarkMode ? "bg-gray-700 border-gray-600" : "bg-gray-50 border-gray-300"}`}>
        <p className={`text-xl font-semibold ${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>OBSERVACIONES</p>
        <Controller
          name="observaciones_ps"
          control={control}
          defaultValue=""
          render={({ field }) => (
            <textarea
              {...field}
              id="observaciones_ps"
              className={`w-full p-4 min-h-[150px] text-sm border-2 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 resize-none ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
              aria-label="observaciones_ps"
              placeholder="Escribe tus observaciones aquí..."
            />
          )}
        />
      </div>

      <div className="grid grid-cols-1 gap-4">
        {/* Campo Resultado */}
        <div className="col-span-1">
          <Label htmlFor="rfc" className={`${isDarkMode ? "text-gray-200" : "text-gray-800"}`}>RESULTADO:</Label>
          <Controller
            name="resultado_conclusion"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <TextInput
                id="resultado_conclusion"
                type="text"
                {...field}
                className={`text-center w-full ${isDarkMode ? "bg-gray-700 text-gray-200 border-gray-600 placeholder-gray-400" : "bg-white text-gray-900 border-gray-300 placeholder-gray-400"}`}
              />
            )}
          />
        </div>
      </div>
    </div>
  );

  return (
    <div className={`min-h-screen ${isDarkMode ? "bg-gray-900" : "bg-gray-50"}`}>
      <div className="container mx-auto p-4">
        <form
          onSubmit={handleSubmit((data) => {
            console.log(data);
            const formData = {
              ...data,
              recomendacion: selectedRecommendation,
              color_ps:
                selectedRecommendation === "recomendable"
                  ? "verde"
                  : selectedRecommendation === "con_reserva"
                  ? "amarillo"
                  : selectedRecommendation === "no_recomendable"
                  ? "rojo"
                  : "",
            };

            // Primero, enviamos la fecha (como ya lo hacías)
            mutateFechaPS.mutate(
              {
                data: { fecha_conclusionps: data.fecha_conclusionps },
                tipo: "put",
              },
              {
                onSuccess: () => {
                  mutateSemaforoPS.mutate(
                    {
                      data: formData,
                      tipo: "post",
                    },
                    {
                      onSuccess: () => {
                        mutateConclusionPS.mutate(
                          {
                            data: formData,
                            tipo: "put",
                          },
                          {
                            onSuccess: () => {
                              mutateResultadoPS.mutate(
                                {
                                  data: formData,
                                  tipo: "post",
                                },
                                {
                                  onSuccess: () => {
                                    navigate(`/psicologica/${evaluadosList_id}`);
                                  },
                                  onError: (error) => {
                                    console.error(
                                      "Error al guardar Resultado PS:",
                                      error
                                    );
                                    console.error(
                                      "Detalles del error:",
                                      error.response.data
                                    );
                                  },
                                }
                              );
                            },
                            onError: (error) => {
                              console.error("Error al guardar Notas PS:", error);
                            },
                          }
                        );
                      },
                      onError: (error) => {
                        console.error("Error al guardar Semáforo PS:", error);
                      },
                    }
                  );
                },
                onError: (error) => {
                  console.error("Error al guardar Fecha Psicologica:", error);
                },
              }
            );
          })}
          className={`max-w-4xl mx-auto rounded-lg shadow-lg overflow-hidden ${isDarkMode ? "bg-gray-800 text-gray-200" : "bg-white text-black"}`}
        >
          {renderHeader()}

          {currentPage === 1 && renderPage1()}
          {currentPage === 2 && renderPage2()}

          <div className="mt-6 p-4 flex justify-between">
            {/* Botón Cancelar */}
            {currentPage === 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  navigate(`/psicologica/${evaluadosList_id}`);
                }}
                className={`ml-2 ${isDarkMode ? "bg-red-600 hover:bg-red-800 text-gray-200" : "bg-red-400 text-white"}`}
              >
                Cancelar
              </Button>
            )}

            {/* Botón Siguiente */}
            {currentPage === 1 && (
              <Button
                type="button"
                className={`ml-2 ${isDarkMode ? "bg-blue-600 hover:bg-blue-800 text-gray-200" : "bg-blue-400 text-white"}`}
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage + 1);
                }}
              >
                Siguiente
              </Button>
            )}

            {currentPage > 1 && (
              <Button
                onClick={() => {
                  window.scrollTo(0, 0);
                  handlePageChange(currentPage - 1);
                }}
                className={`ml-2 ${isDarkMode ? "bg-violet-600 hover:bg-violet-800 text-gray-200" : "bg-violet-500 text-white"}`}
              >
                Anterior
              </Button>
            )}

            {/* Botón Guardar */}
            {currentPage === 2 && (
              <div className="flex space-x-4">
                <Button
                  type="submit"
                  className={`ml-2 ${isDarkMode ? "bg-green-600 hover:bg-green-800 text-gray-200" : "bg-green-400 text-white"}`}
                >
                  Guardar
                </Button>
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};
